import { render, staticRenderFns } from "./CourseVideo.vue?vue&type=template&id=4945b7a0&"
import script from "./CourseVideo.vue?vue&type=script&lang=ts&"
export * from "./CourseVideo.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports